$(document).ready(function () {
    $('.navbar-toggler').click(function () {
        $('body').toggleClass('burger-open');
    });
});